import $ from "jquery";
import Swiper, {Navigation, Pagination} from "swiper";


export default function reviewsSwipe() {

    const swiper = new Swiper(".reviews-swiper", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next-review",
            prevEl: ".swiper-button-prev-review",
        },
    });
}